import { Reducer } from 'redux';
import { isActionOf } from 'typesafe-actions';
import { ACTIVITY_PER_PAGE } from 'utils/config';
import {
  createStandardReducer,
  defaultStandardState,
} from 'utils/createStandardReducer';
import { getActivityBellItems } from './actions';
import { ActivityBellAction, ActivityBellState } from './types';

export const INITIAL_STATE: ActivityBellState = {
  ...defaultStandardState,
};

const reducer: Reducer<ActivityBellState, ActivityBellAction> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default createStandardReducer({
  actions: {
    getMany: {
      request: isActionOf(getActivityBellItems.request),
      success: isActionOf(getActivityBellItems.success),
      failure: isActionOf(getActivityBellItems.failure),
    },
  },
  contractItem: (payload) => payload,
  initialState: INITIAL_STATE,
  perPage: ACTIVITY_PER_PAGE,
})(reducer);
